import { type VersionInfo } from "./versionSchema";

export interface AppMetadata {
  version: VersionInfo;
}

export function createAppMetadata(serverVersion: VersionInfo): AppMetadata {
  return {
    version: serverVersion,
  };
}
